import { useMemo, useRef, useEffect, useState } from "react";
import { PropTypes } from "prop-types";
import { cn } from "@helpers/general";
import { withALErrorBoundary } from "../../helpers/ErrorBoundary/ALErrorBoundary";
import { ComponentType } from "../../constants/ComponentType";

function ProductReviewRating({ componentType, onClick, productId }) {
  const [shouldDisplayReviews, setShouldDisplayReviews] = useState(false);
  const nodeRef = useRef(null);

  const formattedProductId = useMemo(
    () => productId?.replace("gid://shopify/Product/", ""),
    [productId]
  );

  useEffect(() => {
    const target = nodeRef.current;
    if (!target || typeof MutationObserver === "undefined") return;

    const readValue = () => {
      const el = target.querySelector('[itemprop="ratingValue"]');
      if (el) {
        if (Number.parseFloat(el.textContent.trim()) >= 4) {
          setShouldDisplayReviews(true);
        }
      }
      const warButton = target.querySelector(".bv_war_button");
      try {
        if (
          warButton &&
          (componentType === ComponentType.PDP_ADS ||
            componentType === ComponentType.CP_BYOB_QUICKVIEW)
        ) {
          // Hidden button to open reviews modal
          warButton.style.setProperty("display", "none", "important");
        }
      } catch (e) {
        console.log(e, " => error hide war button");
      }
    };

    readValue();

    const observer = new MutationObserver((mutations) => {
      if (mutations.some((m) => m.type === "childList" || m.type === "characterData")) {
        readValue();
      }
    });

    observer.observe(target, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    return () => observer.disconnect();
  }, []);

  if (!formattedProductId) {
    return null;
  }
  return (
    <div
      className={`
      ${componentType === ComponentType.REVIEWS ? "pdp_details_reviews_list" : ""}
        ${componentType === ComponentType.PRODUCT_CAROUSEL ? "p-0 mt-[5px]" : ""}
        ${componentType === ComponentType.PDP_ADS ? "pdp_ads_details_reviews" : ""}
        `}
      onClick={onClick}
      data-testid="reviews-rating-block"
    >
      <div
        className={`${cn(!shouldDisplayReviews && "hidden")}`}
        ref={nodeRef}
        data-bv-show="rating_summary"
        data-bv-product-id={formattedProductId}
      />
    </div>
  );
}

ProductReviewRating.propTypes = {
  componentType: PropTypes.oneOf(Object.values(ComponentType)),
  onClick: PropTypes.func,
  productId: PropTypes.string,
};

export default withALErrorBoundary({
  name: "ProductReviewRating",
  priority: "P2",
})(ProductReviewRating);
